import { jsx as _jsx } from "react/jsx-runtime";
import { LaborClinEditor } from './LaborClinEditor';
export function GenericClinEditor(props) {
    return /*#__PURE__*/ _jsx(LaborClinEditor, {
        ...props,
        kind: "Generic"
    });
}
